import type { SagaIterator } from 'redux-saga'
import { all, fork, takeLatest } from 'redux-saga/effects'
import type { ActionType } from '../types/action-type'
import chatSagas from './chat'
import { contactFormSubmit } from './contact-form-submit'

export const rootSaga = function* root(): SagaIterator {
  yield all([fork(chatSagas), takeLatest('CONTACT_FORM_SUBMIT' as ActionType, contactFormSubmit)])
}
